import { useMemo } from "react";
import Tabbar from "components/molecules/Tabbar";
import { useNotificationUserBonuses } from "hooks/useNotificationUserBonuses";
import { formatNotificationTabBar } from "helpers/notificationsNavigation";

const TabBarContainer = () => {
  const { isActive: bonusesNotificationActive } = useNotificationUserBonuses();
  const notifications = useMemo(
    () =>
      formatNotificationTabBar({
        menu: bonusesNotificationActive,
      }),
    [bonusesNotificationActive],
  );

  return <Tabbar notifications={notifications} />;
};

export default TabBarContainer;
